<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M5,4C4.45,4,4,4.45,4,5C4,5.55,4.45,6,5,6C5.55,6,6,5.55,6,5C6,4.45,5.55,4,5,4C5,4,5,4,5,4ZM4,7C3.45,7,3,7.45,3,8C3,8.55,3.45,9,4,9C4.55,9,5,8.55,5,8C5,7.45,4.55,7,4,7C4,7,4,7,4,7ZM8,5C8.55,5,9,4.55,9,4C9,3.45,8.55,3,8,3C7.45,3,7,3.45,7,4C7,4.55,7.45,5,8,5C8,5,8,5,8,5ZM6,11C6,12.1,6.9,13,8,13C9.1,13,10,12.1,10,11C10,10.47,8,6,8,6C8,6,6,10.47,6,11C6,11,6,11,6,11ZM8,0C3.58,0,0,3.58,0,8C0,12.42,3.58,16,8,16C12.42,16,16,12.42,16,8C16,3.58,12.42,0,8,0C8,0,8,0,8,0ZM8,14C4.69,14,2,11.31,2,8C2,4.69,4.69,2,8,2C11.31,2,14,4.69,14,8C14,11.31,11.31,14,8,14C8,14,8,14,8,14ZM12,5C12,4.45,11.55,4,11,4C10.45,4,10,4.45,10,5C10,5.55,10.45,6,11,6C11.55,6,12,5.55,12,5C12,5,12,5,12,5ZM12,7C11.45,7,11,7.45,11,8C11,8.55,11.45,9,12,9C12.55,9,13,8.55,13,8C13,7.45,12.55,7,12,7C12,7,12,7,12,7Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Dashboard',
} as DefineComponent
</script>
